<template>
  <div
    class="from-gp-midnight-3-a to-gp-midnight-3-b z-13 bg-linear-to-r fixed inset-x-0 top-[72px] rounded-b bg-cover bg-top shadow-xl md:rounded-b-none xl:left-[320px] xl:top-0"
    :class="props.visible ? 'visible' : 'invisible'"
  >
    <div ref="container">
      <!-- slide server name stuff in from top -->
      <header-server-name
        :scrolled="true"
        class="transition-transform xl:pt-5"
        :class="props.visible ? 'translate-y-0' : '-translate-y-10 xl:-translate-y-24'"
      />
      <div
        class="flex cursor-pointer select-none items-center justify-center gap-2 pb-2 md:hidden"
        @click="mobileDetailsOpened = !mobileDetailsOpened"
      >
        <font-awesome-icon
          class="text-gp-rhino w-7 text-3xl"
          :icon="mobileDetailsOpened ? faEllipsisStroke : faEllipsis"
        />
        {{ t(`ngp/header/server_details/${mobileDetailsOpened ? "hide" : "show"}`) }}
      </div>
      <header-server-details class="px-4 pb-5 md:pt-5" :class="mobileDetailsOpened ? '' : 'hidden md:block'" />
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

import { faEllipsisStroke } from "@fortawesome/pro-light-svg-icons";
import { faEllipsis } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useElementBounding } from "@vueuse/core";
import HeaderServerDetails from "./HeaderServerDetails.vue";
import HeaderServerName from "./HeaderServerName.vue";
import { headerScrolledCoreHeight, headerScrolledCoreTopOffset } from "./height";

const { t } = useI18n();

const props = defineProps<{
  visible: boolean;
}>();

const mobileDetailsOpened = ref(false);

// Hide mobile server details when visibility of the scrolled header changes
watch(
  () => props.visible,
  () => {
    mobileDetailsOpened.value = false;
  },
);

const container = ref();
const { height, top } = useElementBounding(container);

watchEffect(() => {
  headerScrolledCoreHeight.value = height.value;
  headerScrolledCoreTopOffset.value = height.value + top.value;
});
</script>
